import { Link } from "react-router-dom";
import EllipsisText from "components/EllipsisText";
import { EditOutlined } from "@ant-design/icons";

const columns = [
  {
    title: "ID urządzenia",
    dataIndex: "imei",
    sortable: true,
    searchable: true,
    search_method: "matches",
    render: (_, { id, imei }) => (
      <Link to={`/devices/${id}`}>
        <EllipsisText text={imei} limit={30} /> <EditOutlined />
      </Link>
    ),
  },
  {
    title: "Nazwa",
    dataIndex: "name",
    sortable: true,
    searchable: true,
    search_method: "matches",
    render: (_, { name }) => <EllipsisText text={name} limit={30} />,
  },
];

export default columns;
